(function () {
  var COOKIE_NAME = 'bellissimo_active_brand';
  var DEFAULT_BRAND = 'bellissimo';

  // Matches the mockups: active brand sits in the center slot,
  // the other two keep their relative left/right order.
  var ORDER = {
    bellissimo: { bellissimo: 2, b: 3, bella: 1 },
    b: { bellissimo: 1, b: 2, bella: 3 },
    bella: { bellissimo: 1, b: 3, bella: 2 }
  };

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value) {
    var maxAge = 60 * 60 * 24 * 365;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function normalizePath(pathname) {
    if (!pathname) return '/';
    var trimmed = pathname.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
  }

  function pathnameFromUrl(url) {
    if (!url) return null;
    try {
      return normalizePath(new URL(url, window.location.origin).pathname);
    } catch (e) {
      return null;
    }
  }

  // Figures out which brand the CURRENT PAGE actually belongs to, based on
  // the brand_*_url settings, so a direct visit/bookmark/shared link to a
  // brand page shows that brand as active even if the cookie says otherwise
  // (or hasn't been set yet).
  function detectBrandFromLocation(root) {
    if (!root) return null;
    var current = normalizePath(window.location.pathname);
    var brands = ['bellissimo', 'b', 'bella'];
    for (var i = 0; i < brands.length; i++) {
      var brand = brands[i];
      var attr = 'data-' + (brand === 'bellissimo' ? 'bellissimo' : brand) + '-url';
      var path = pathnameFromUrl(root.getAttribute(attr));
      if (path && path === current) return brand;
    }
    return null;
  }

  function applyBrand(root, brand) {
    var order = ORDER[brand] || ORDER[DEFAULT_BRAND];
    var buttons = root.querySelectorAll('[data-brand-option]');

    buttons.forEach(function (btn) {
      var key = btn.getAttribute('data-brand-option');
      var isActive = key === brand;
      btn.setAttribute('data-active', isActive ? 'true' : 'false');
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.style.order = order[key];
    });

    document.documentElement.setAttribute('data-brand', brand);

    var bgAttr = 'data-' + (brand === 'bellissimo' ? 'bellissimo' : brand) + '-bg';
    var bg = root.getAttribute(bgAttr);
    // The theme paints the page body via var(--colorBody) and the sticky
    // header bar separately via var(--colorNav) (assets/theme.css.liquid).
    // Both need to be set or the header stays the default color while the
    // rest of the page recolors.
    if (bg) {
      document.documentElement.style.setProperty('--colorBody', bg);
      document.documentElement.style.setProperty('--colorNav', bg);
    } else {
      document.documentElement.style.removeProperty('--colorBody');
      document.documentElement.style.removeProperty('--colorNav');
    }

    var msgAttr = 'data-' + (brand === 'bellissimo' ? 'bellissimo' : brand) + '-msg';
    var msg = root.getAttribute(msgAttr);
    if (msg) {
      var textEl = document.querySelector('.announcement-text');
      if (textEl) {
        textEl.textContent = msg;
      }
    }
  }

  function init() {
    var switchers = document.querySelectorAll('[data-brand-switcher]');

    var cookieBrand = getCookie(COOKIE_NAME);
    var activeBrand = cookieBrand || DEFAULT_BRAND;
    if (!ORDER[activeBrand]) activeBrand = DEFAULT_BRAND;

    // If the current URL matches one of the brand pages, that takes
    // priority over a stale/missing cookie — this is the fix for landing
    // on e.g. the Bella Hats page directly and seeing Bellissimo active.
    if (switchers.length) {
      var urlBrand = detectBrandFromLocation(switchers[0]) || document.documentElement.getAttribute('data-brand-initial');
      if (urlBrand && urlBrand !== activeBrand) {
        activeBrand = urlBrand;
        setCookie(COOKIE_NAME, activeBrand);
      }
    }

    // Always reflect the active brand on <html>, even on pages/templates
    // that don't render the switcher markup, so background color, the
    // [data-menu-brand] CSS, etc. stay correct instead of silently falling
    // back to the Bellissimo default.
    document.documentElement.setAttribute('data-brand', activeBrand);

    if (!switchers.length) return;

    switchers.forEach(function (root) {
      applyBrand(root, activeBrand);

      if (root.dataset.brandSwitcherBound) return;
      root.dataset.brandSwitcherBound = 'true';

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-brand-option]');
        if (!btn) return;

        var brand = btn.getAttribute('data-brand-option');
        setCookie(COOKIE_NAME, brand);

        switchers.forEach(function (r) {
          applyBrand(r, brand);
        });

        var urlAttr = 'data-' + (brand === 'bellissimo' ? 'bellissimo' : brand) + '-url';
        var url = root.getAttribute(urlAttr);
        if (url && url !== window.location.pathname) {
          window.location.href = url;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  // Safari/Firefox restore pages from bfcache on back/forward navigation
  // without re-running DOMContentLoaded, which left the header showing a
  // stale brand. Re-apply whenever a page is shown from cache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });
})();